/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyMiscBillItem from './pharmacy-misc-bill-item';
import PharmacyMiscBillItemDetail from './pharmacy-misc-bill-item-detail';
import PharmacyMiscBillItemUpdate from './pharmacy-misc-bill-item-update';
import PharmacyMiscBillItemDeleteDialog from './pharmacy-misc-bill-item-delete-dialog';

const PharmacyMiscBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyMiscBillItem />} />
    <Route path="new" element={<PharmacyMiscBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyMiscBillItemDetail />} />
      <Route path="edit" element={<PharmacyMiscBillItemUpdate />} />
      <Route path="delete" element={<PharmacyMiscBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyMiscBillItemRoutes;
